<template>
    <div>FormGen</div>
</template>

<script>
export default {
    name: 'FormGen',
}
</script>